import { Box, Button, FormControl, FormControlLabel, FormHelperText, InputAdornment, InputLabel, OutlinedInput, Switch, TextField, Typography } from "@mui/material";
import { useState } from "react";
import { CardUploadImagem } from "../../../core/components/CardUploadImagem";
import { IConfiguracaoPeso } from "../../interfaces/IConfiguracaoPeso";
import { IImagemProduto } from "../../interfaces/IImagemProduto";
import { useCadastrarEditarProdutoContext } from "../../contexts/CadastrarEditarProdutoContext";
import {
    ButtonsContainerForm,
    ConfiguracaoContainer,
    Formulario,
    FormularioPaper,
    ImagemContainer,
} from "../ConfiguracaoPreparadoContainer/styles";

export const ConfiguracaoPesoContainer = () => {
    const {
        descricao,
        setDescricao,
        registrarConfiguracoesPeso,
        handleExcluirImagem,
        handleUploadImagem,
        imagens,
        configuracaoPeso,
    } = useCadastrarEditarProdutoContext();

    const [precoPorKg, setPrecoPorKg] = useState<string>(
        configuracaoPeso?.precoPorKg ? String(configuracaoPeso.precoPorKg) : ''
    );
    const [habilitarTeto, setHabilitarTeto] = useState(!!configuracaoPeso?.valorTeto);
    const [valorTeto, setValorTeto] = useState<string>(
        configuracaoPeso?.valorTeto ? String(configuracaoPeso.valorTeto) : ''
    );
    const [erros, setErros] = useState<{ precoPorKg?: string; valorTeto?: string; descricao?: string }>({});

    const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        const novosErros: typeof erros = {};

        if (!descricao) novosErros.descricao = 'Descrição inválida';

        const precoNum = parseFloat(precoPorKg.replace(',', '.'));
        if (!precoPorKg || isNaN(precoNum) || precoNum <= 0) {
            novosErros.precoPorKg = 'Preço por kg inválido';
        }

        if (habilitarTeto) {
            const tetoNum = parseFloat(valorTeto.replace(',', '.'));
            if (!valorTeto || isNaN(tetoNum) || tetoNum <= 0) {
                novosErros.valorTeto = 'Valor teto inválido';
            }
        }

        if (Object.keys(novosErros).length > 0) {
            setErros(novosErros);
            return;
        }

        const config: IConfiguracaoPeso = {
            precoPorKg: parseFloat(precoPorKg.replace(',', '.')),
            valorTeto: habilitarTeto ? parseFloat(valorTeto.replace(',', '.')) : undefined,
        };

        registrarConfiguracoesPeso(config);
    };

    return (
        <ConfiguracaoContainer>
            <FormularioPaper>
                <Formulario onSubmit={handleSubmit}>
                    <Typography variant="h6" sx={{ width: "100%", marginBottom: "1rem" }}>
                        Configuração — Produto por peso
                    </Typography>
                    <FormControl sx={{ marginTop: "1rem" }} fullWidth>
                        <TextField
                            label="Nome"
                            value={descricao ?? ''}
                            onChange={(e) => setDescricao(e.target.value)}
                            error={!!erros.descricao}
                            helperText={erros.descricao}
                            InputLabelProps={{ shrink: true }}
                            placeholder="Ex: Buffet quente, salada..."
                        />
                    </FormControl>
                    <FormControl sx={{ marginTop: "1.5rem" }} fullWidth error={!!erros.precoPorKg}>
                        <InputLabel htmlFor="preco-por-kg">Preço por Kg (R$/kg)</InputLabel>
                        <OutlinedInput
                            id="preco-por-kg"
                            startAdornment={<InputAdornment position="start">R$</InputAdornment>}
                            endAdornment={<InputAdornment position="end">/kg</InputAdornment>}
                            label="Preço por Kg (R$/kg)"
                            value={precoPorKg}
                            onChange={(e) => setPrecoPorKg(e.target.value)}
                            placeholder="Ex: 49,90"
                            type="number"
                            inputProps={{ min: 0.01, step: 0.01 }}
                        />
                        {!!erros.precoPorKg && <FormHelperText>{erros.precoPorKg}</FormHelperText>}
                    </FormControl>
                    <FormControlLabel
                        sx={{ marginTop: "1.5rem" }}
                        control={<Switch checked={habilitarTeto} onChange={() => setHabilitarTeto(!habilitarTeto)} />}
                        label="Habilitar buffet livre (valor teto)"
                    />
                    {habilitarTeto && (
                        <FormControl sx={{ marginTop: "1rem" }} fullWidth error={!!erros.valorTeto}>
                            <InputLabel htmlFor="valor-teto">Valor teto (R$)</InputLabel>
                            <OutlinedInput
                                id="valor-teto"
                                startAdornment={<InputAdornment position="start">R$</InputAdornment>}
                                label="Valor teto (R$)"
                                value={valorTeto}
                                onChange={(e) => setValorTeto(e.target.value)}
                                placeholder="Ex: 39,90"
                                type="number"
                                inputProps={{ min: 0.01, step: 0.01 }}
                            />
                            {!!erros.valorTeto && <FormHelperText>{erros.valorTeto}</FormHelperText>}
                        </FormControl>
                    )}
                    <ImagemContainer>
                        <CardUploadImagem
                            titulo="Imagem"
                            descricao={
                                imagens[0]
                                    ? (imagens[0] instanceof File ? imagens[0]?.name : ((imagens[0] as IImagemProduto)?.nomeOriginal ?? (imagens[0] as IImagemProduto)?.nome))
                                    : "Faça o upload"
                            }
                            url={imagens[0] instanceof File ? URL.createObjectURL(imagens[0]) : (imagens[0] as IImagemProduto)?.url}
                            excluir={handleExcluirImagem}
                            upload={handleUploadImagem}
                        />
                    </ImagemContainer>
                    <ButtonsContainerForm>
                        <Box />
                        <Button size="medium" variant="contained" type="submit">
                            Próximo
                        </Button>
                    </ButtonsContainerForm>
                </Formulario>
            </FormularioPaper>

        </ConfiguracaoContainer>
    );
};
